/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ExpireWarningIcon extends BaseIcon {
  getChildren = () => [
    <g>
      <circle fill='#f8b72c' cx="21" cy="21" r="19.5"/>
      <path fill='#fff' d="M21,3A18,18,0,1,1,3,21,18,18,0,0,1,21,3m0-3A21,21,0,1,0,42,21,21,21,0,0,0,21,0Z"/>
    </g>,
    <polygon fill='#fff' points="10.43 13.1 21.83 21.1 30.2 15.55 21.32 25.42 10.43 13.1"/>
  ]
  getViewBox = () => '0 0 42 42'
}
